jQuery(function($) {

    var delayTimer;
    var map = null;
    var currentMarker = null; // Variable to hold the currently open marker

    function sendRequest() {
        var filter = $('#filter');
        $('#loading').show();
        $.ajax({
            url: filter.attr('action'),
            data: filter.serialize(), // form data
            type: filter.attr('method'), // POST
            dataType: 'json', // Set the expected response data type
            success: function(response) {
                $('#response').html(response.result);

                var newLocations = response.locations;
                updateMarkers(newLocations);

            },
            complete: function() {
                // Hide the loading GIF image after the request is complete
                $('#loading').hide();
            }
        });
    }




    function updateMarkers(locations) {
        if (!map || typeof google === 'undefined' || !google.maps) {
            return;
        }

        // Remove existing markers from the map
        for (var i = 0; i < map.markers.length; i++) {
            map.markers[i].setMap(null);
        }

        map.markers = [];

        // Add new markers to the map
        if (locations) {
        for (var j = 0; j < locations.length; j++) {
            var location = locations[j];
            var marker = new google.maps.Marker({
                position: { lat: location.latitude, lng: location.longitude },
                map: map
            });

            // If location content exists, create an info window for the marker
            if (location.content) {
                var infowindow = new google.maps.InfoWindow();

                // Show info window when marker is clicked
                marker.addListener('click', function (marker, infowindow) {
                    return function () {

                        // Close the previously open marker
                        if (currentMarker) {
                            currentMarker.infowindow.close();
                        }

                        infowindow.setContent(marker.content);
                        infowindow.open(map, marker);

                        // Update the currently open marker
                        currentMarker = {
                            marker: marker,
                            infowindow: infowindow
                        };

                    };
                }(marker, infowindow)); // Use a closure to preserve the values of marker and infowindow

                // Assign the content to the marker
                marker.content = location.content;
            }

            // Push the new marker to the map markers array
            map.markers.push(marker);
        }
        }

        // Center the map based on the new markers only if the map is currently visible
      //  if (googlemapDiv.style.display !== 'none') {
            centerMap();
      //  }
    }

    function centerMap() {

        if (!map || !map.markers || map.markers.length === 0) {
            return;
        }

        var bounds = new google.maps.LatLngBounds();

        map.markers.forEach(function(marker) {
            bounds.extend(marker.getPosition());
        });

        map.fitBounds(bounds);
    }

    // Initialize the map
    function initMap() {

        if (typeof google === 'undefined' || !google.maps) {
            console.warn('Google Maps not available (cookie consent blocked it)');
            return;
        }

        map = new google.maps.Map(document.getElementById('acf-map'), {
            zoom: 14,
            mapTypeId: google.maps.MapTypeId.ROADMAP
        });

        map.markers = [];
    }

    initMap();
    setTimeout(sendRequest, 50);

    /*
    $('#filter .terminaalit-select').on('change', function() {
        clearTimeout(delayTimer);
        delayTimer = setTimeout(sendRequest, 500);
    }); */

    $('#filter input, #filter select').on('keyup change click', function() {
        clearTimeout(delayTimer); // Clear the previous timer
        delayTimer = setTimeout(sendRequest, 500); // Set a delay of 500 milliseconds before sending the request
    });

    var input = document.getElementById("hakusanakentta");
    input.addEventListener("keydown", function(event) {
      if (event.key === "Enter") {
        event.preventDefault(); // Prevent form submission
      }
    });



    function setupCheckboxBehavior(container) {
        // Get the "Check All" checkbox and all individual checkboxes
        const checkAllCheckbox = container.querySelector('.checkall');
        const singleCheckboxes = container.querySelectorAll('.singlecheckbox');

        // Add a click event listener to the "Check All" checkbox
        checkAllCheckbox.addEventListener('click', function () {
            // Loop through all individual checkboxes and set their checked property
            singleCheckboxes.forEach(function (checkbox) {
                checkbox.checked = checkAllCheckbox.checked;
            });
        });

        // Add a click event listener to each "singlecheckbox" checkbox
        singleCheckboxes.forEach(function (checkbox) {
            checkbox.addEventListener('click', function () {
                // Check if all "singlecheckbox" checkboxes are checked
                const allChecked = Array.from(singleCheckboxes).every(function (singleCheckbox) {
                return singleCheckbox.checked;
                });
                // Check if none of the "singlecheckbox" checkboxes are checked
                const noneChecked = Array.from(singleCheckboxes).every(function (singleCheckbox) {
                    return !singleCheckbox.checked;
                });

                // Update the "checkall" checkbox based on the status of "singlecheckbox" checkboxes
                checkAllCheckbox.checked = allChecked || noneChecked;
            });
        });
    }

    const pakkauslajitElements = document.querySelectorAll('.pakkauslajit');

    pakkauslajitElements.forEach(function (pakkauslajitElement) {
        setupCheckboxBehavior(pakkauslajitElement);

        const svgsElement = document.querySelector('.svgs');

        // Check screen width and apply different behavior
        if (window.innerWidth >= 720) {
          // Add event listener for hover on screens wider than 720px
          pakkauslajitElement.addEventListener('mouseover', function() {
            pakkauslajitElement.classList.add('opened');
          });

          pakkauslajitElement.addEventListener('mouseout', function() {
            pakkauslajitElement.classList.remove('opened');
          });
        } else {
          // Add event listener for click on screens narrower than 720px
          svgsElement.addEventListener('click', function() {
            pakkauslajitElement.classList.toggle('opened');
          });
        }
    });







});

